module.exports = __webpack_public_path__ + "static/img/road.347b691.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/road.png
// module id = nJKU
// module chunks = 1